import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { noop } from 'Helpers/PropTypes';
import {
  EditMessageActionBar,
} from 'Components/ComponentLibrary/Components/Uncategorized/EditMessageInput/components/EditMessageActionBar';
import {
  RichTextEditorInputField,
} from 'Components/ComponentLibrary/Components/Uncategorized/RichTextEditorInputField';
import {
  DEFAULT_INPUT_MIN_HEIGHT_FOR_MESSAGE_EDIT,
} from 'Components/ComponentLibrary/Components/Uncategorized/EditMessageInput/EditMessageInput';

const useStyles = buildUseStyles('AgentEditMessageInput', (theme) => ({
  root: {
    paddingTop: theme.spacing(1),
  },
  button: {
    margin: 0,
  },
  bottomToolbar: {
    marginTop: theme.spacing(1),
  },
}));


const AgentEditMessageInput = ({
  className,
  handleSubmit,
  handleChange,
  onClose,
  value,
  rounded,
  inputMinHeight,
  customConfig,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Box className={classNames(className, classes.root)}>
      <RichTextEditorInputField
        onChange={handleChange}
        value={value}
        rounded={rounded}
        customConfig={customConfig}
        inputMinHeight={inputMinHeight}
      />
      <EditMessageActionBar
        className={classes.bottomToolbar}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </Box>
  );
};

AgentEditMessageInput.defaultProps = {
  className: '',
  handleChange: noop,
  handleSubmit: noop,
  onClose: noop,
  value: '',
  rounded: false,
  inputMinHeight: DEFAULT_INPUT_MIN_HEIGHT_FOR_MESSAGE_EDIT,
  customConfig: {},
};

AgentEditMessageInput.propTypes = {
  className: PropTypes.string,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  onClose: PropTypes.func,
  value: PropTypes.string,
  rounded: PropTypes.bool,
  inputMinHeight: PropTypes.number,
  customConfig: PropTypes.object,
};

export { AgentEditMessageInput };
